import { useEffect, useState } from 'react'
import Architecture from '../logic/Architecture'
import { PageHandle } from '../logic/Guide'
import { Scenario } from '../logic/scenarios/data'
import Top from './Top'
import Wizard from './Wizard'
import GuideViewer from './GuideViewer'

type UIProps = {
    scenario: Scenario
    architecture: Architecture
    pageHandle: PageHandle
    isPrint: boolean
    initWizard: boolean
    licenseID?: string
    setPrint: (print: boolean) => void
    navigate: (handle?: PageHandle) => void
    setScenario: (scenario: Scenario) => void
}

const UI = ({ isPrint, setPrint, scenario, setScenario, initWizard, ...props }: UIProps) => {

    const [isWizardOpen, setWizardOpen] = useState(initWizard)
    const openWizard = () => setWizardOpen(true)

    // Force open the wizard when initWizard was set
    useEffect(() => {
        setWizardOpen(initWizard)
    }, [initWizard])
    
    return (
        <>
            <Top isPrint={isPrint} setPrint={setPrint} openWizard={openWizard} />
            <Wizard isOpen={isWizardOpen} scenario={scenario} close={() => setWizardOpen(false)} setScenario={setScenario} />
            <div className="App">
                <GuideViewer scenario={scenario} isPrint={isPrint} {...props}/>
            </div>
        </>
    )    
}

export default UI